import { useQuery } from '@tanstack/react-query';
import type { ListResponse, UserOption } from '@proerp/shared';
import { apiRequest } from './apiClient';

/**
 * Aktive Nutzer als Auswahl-Liste (id + Anzeigename) — z. B. für das
 * Sachbearbeiter-Feld am Beleg. Für alle eingeloggten Nutzer abrufbar
 * (kein Admin-Recht nötig, Endpoint liefert bewusst nur id + Name).
 */
export function useUserOptions() {
  return useQuery({
    queryKey: ['users', 'options'],
    queryFn: () => apiRequest<ListResponse<UserOption>>('/v1/users/options'),
    staleTime: 5 * 60 * 1000,
  });
}
